<template>
  <div class="metric-card">
    <div class="metric-card__header">
      <div class="metric-card__icon">
        <svg v-if="header === 'Amount raised'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="header === 'Secondary Valuation'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 6H23V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="metric-card__label">{{ header }}</span>
      <button 
        class="metric-card__toggle" 
        @click="showBalance = !showBalance"
        :aria-label="showBalance ? 'Hide balance' : 'Show balance'"
      >
        <svg v-if="showBalance" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
        </svg>
        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99836 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1 1L23 23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    
    <div class="metric-card__value">
      <span class="metric-value">{{ toggledBalance }}</span>
    </div>

    <div class="metric-card__footer">
      <div class="metric-subtext">
        <span class="metric-subtext__label">{{ subText }}</span>
        <span class="metric-subtext__value">
          {{ showBalance ? formatAmountToDollar(subAmount, 2, currency) : "•••••" }}
        </span>
      </div>
      <button
        v-if="hasButton && header !== 'Amount raised'"
        class="metric-card__btn"
        @click="$emit('button-click')"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
  import { formatAmountToDollar } from "@/utils/helpers.js";
  import { getItem, setItem } from "@/utils/storage";

  export default {
    name: "OverviewCard",
    data() {
      return {
        showBalance: true,
      };
    },
    emits: ["button-click"],

    props: {
      header: { type: String, default: () => "", required: true },
      subText: { type: String, default: () => "", required: true },
      balance: { type: Number, default: () => 0 },
      subAmount: { type: Number, default: () => 0 },
      hasButton: {
        type: Boolean,
        required: false,
      },
      buttonText: {
        type: String,
        required: false,
      },
      currency: {
        type: String,
        default: 'USD'
      }
    },
    computed: {
      toggledBalance() {
        let balance = null;
        switch (this.showBalance) {
          case true:
            balance = this.formatAmountToDollar(this.balance, 2, this.currency);
            break;
          case false:
            balance = "*******";
            break;
        }
        return balance;
      },
    },
    watch: {
      showBalance(val) {
        setItem("showBalance", val);
      },
    },

    mounted() {
      this.showBalance =
        getItem("showBalance") !== null ? getItem("showBalance") : true;
    },

    methods: {
      formatAmountToDollar,
    },
  };
</script>

<style lang="scss" scoped>
.metric-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  width: 100%;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
  }
}

.metric-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.metric-card__icon {
  width: 36px;
  height: 36px;
  background: rgba(77, 132, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4d84ff;
}

.metric-card__label {
  flex: 1;
  font-size: 13px;
  font-weight: 400;
  color: #475569;
  text-transform: capitalize;
}

.metric-card__toggle {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #94a3b8;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    color: #475569;
  }
}

.metric-card__value {
  margin-bottom: 16px;
}

.metric-value {
  font-size: 28px;
  font-weight: 500;
  color: #0f172a;
  letter-spacing: -0.5px;
}

.metric-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.metric-subtext {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.metric-subtext__label {
  font-size: 12px;
  color: #94a3b8;
}

.metric-subtext__value {
  font-size: 14px;
  font-weight: 500;
  color: #4d84ff;
}

.metric-card__btn {
  padding: 10px 16px;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1e293b;
  }
}
</style>
